import React from "react";

export function PartnerCard({ title, imgUrl, description, link }) {
  return (
    <div className="group relative bg-white rounded-xl  shadow-lg overflow-hidden transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl">
      <div className="relative h-64 overflow-hidden">
        <div className="absolute top-4 right-4 z-10"></div>
        <div className="w-full h-56 flex items-center justify-center p-4">
          <img
            src={imgUrl}
            className="max-w-full max-h-56 mt-10 object-contain transform transition duration-500 group-hover:scale-110"
            alt={title}
          />
        </div>

        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
          <div className="p-4 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300"></div>
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-2xl font-bold text-orange-600 -mt-0">{title}</h3>
        </div>
        <p className="text-1xl mb-5 ">{description}</p>
        <p className="text-gray-600 mb-4 line-clamp-3"> </p>
        <div className="flex justify-between items-center">
          <a
            href={link}
            className="inline-flex items-center text-orange-500 font-semibold group"
          >
            <span className="mr-2">Read More</span>
            <svg
              className="w-4 h-4 transform transition-transform duration-300 group-hover:translate-x-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              ></path>
            </svg>
          </a>
          <div className="flex space-x-2">
            <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
            <span className="w-2 h-2 bg-orange-300 rounded-full"></span>
            <span className="w-2 h-2 bg-orange-200 rounded-full"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
